export default "__VITE_ASSET__nG1b0O1R__"